import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import React, { useState, useEffect } from 'react'

import BrandSelector from '../generic/BrandSelector'

interface SourceLoadingProps {
  source: string
}
const SourceLoading: React.FC<SourceLoadingProps> = ({ source }) => {
  const [isCompleted, setIsCompleted] = useState(false)

  useEffect(() => {
    const randomInteger = Math.floor(Math.random() * (4 - 2 + 1)) + 2
    const interval = setInterval(() => {
      setIsCompleted(true)
    }, randomInteger * 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
      <BrandSelector width={88} height={40} name={source} />
      {isCompleted ? <CheckCircleIcon color="success" /> : <CircularProgress />}
    </Stack>
  )
}

export default SourceLoading
